import React, { useState, useEffect } from "react";
import { t, getLang } from "./i18n";

var dLoc = function(){ return ({ pt: "pt-BR", es: "es-ES", en: "en-US" })[getLang()] || "pt-BR"; };
var stLbl = function(x){ var k = "st." + String(x).split(" ").join("_"); var v = t(k); return v === k ? x : v; };

const API_BASE = window.location.hostname === "localhost" ? "http://localhost:3000" : "";
async function apiFetch(path, opts = {}) {
  const token = window.__auroraToken || sessionStorage.getItem("aurora_token");
  const headers = { "Content-Type": "application/json", ...(token ? { Authorization: "Bearer " + token } : {}) };
  const res = await fetch(API_BASE + path, { ...opts, headers });
  if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.error || "Erro " + res.status); }
  return res.json();
}

const h1 = { fontSize: 22, fontWeight: 600, color: "#111827", margin: 0 };
const sub = { fontSize: 13, color: "#6B7280", marginTop: 2 };
const card = { background: "#fff", borderRadius: 10, padding: 20, boxShadow: "0 1px 3px rgba(0,0,0,.08)", marginBottom: 16 };
const label = { display: "block", fontSize: 12, fontWeight: 500, color: "#374151", marginBottom: 4 };
const inp = { width: "100%", padding: "8px 10px", border: "1px solid #D1D5DB", borderRadius: 6, fontSize: 13, boxSizing: "border-box" };
const btnP = { padding: "9px 20px", background: "#F59E0B", color: "#fff", border: "none", borderRadius: 6, fontWeight: 500, cursor: "pointer", fontSize: 13 };
const btnS = { padding: "7px 14px", background: "#F3F4F6", color: "#374151", border: "1px solid #D1D5DB", borderRadius: 6, cursor: "pointer", fontSize: 12 };
const btnD = { padding: "7px 14px", background: "#DC2626", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 12 };
const badgeS = (s) => {
  const m = { autorizada: ["#065F46","#D1FAE5"], cancelada: ["#92400E","#FEF3C7"], erro: ["#991B1B","#FEE2E2"] };
  const [c,b] = m[s] || ["#6B7280","#F3F4F6"];
  return { display:"inline-block", padding:"2px 8px", borderRadius:10, fontSize:11, fontWeight:500, color:c, background:b };
};
const FORMAS_PAG = [
  {v:"01",l:"Dinheiro"},{v:"02",l:"Cheque"},{v:"03",l:"Cartão Crédito"},{v:"04",l:"Cartão Débito"},{v:"05",l:"Crédito Loja"},
  {v:"10",l:"Vale Alimentação"},{v:"11",l:"Vale Refeição"},{v:"12",l:"Vale Presente"},{v:"13",l:"Vale Combustível"},
  {v:"15",l:"Boleto"},{v:"16",l:"Depósito"},{v:"17",l:"PIX"},{v:"18",l:"Transferência"},{v:"99",l:"Outros"}
];
const emptyItem = { descricao:"", quantidade:1, valor_unitario:"", ncm:"", cfop:"5102", unidade:"UN" };

export default function FiscalPage() {
  const [tab, setTab] = useState("notes");
  const [config, setConfig] = useState(null);
  const [notes, setNotes] = useState([]);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(true);
  // Emissão
  const [showEmit, setShowEmit] = useState(false);
  const [emitTipo, setEmitTipo] = useState("nfce");
  const [emitCliente, setEmitCliente] = useState({ cpf:"", cnpj:"", nome:"", email:"" });
  const [emitItens, setEmitItens] = useState([{ ...emptyItem }]);
  const [emitPag, setEmitPag] = useState([{ forma:"17", valor:"" }]);
  const [emitting, setEmitting] = useState(false);
  const [emitMsg, setEmitMsg] = useState("");

  useEffect(() => { loadConfig(); loadNotes(); }, []);

  async function loadConfig() {
    try { const c = await apiFetch("/api/fiscal/config"); if (c) { setConfig(c); setForm(c); } } catch(e){}
    setLoading(false);
  }
  async function loadNotes() {
    try { setNotes(await apiFetch("/api/fiscal/notas")); } catch(e){}
  }
  async function saveConfig() {
    setSaving(true); setMsg("");
    try { const r = await apiFetch("/api/fiscal/config", { method:"POST", body:JSON.stringify(form) }); setConfig(r); setForm(r); setMsg(t("fs.configSaved")); setTimeout(()=>setMsg(""),3000); }
    catch(e){ setMsg(t("fs.error")+e.message); }
    setSaving(false);
  }

  function addItem() { setEmitItens([...emitItens, { ...emptyItem }]); }
  function removeItem(i) { if(emitItens.length>1) setEmitItens(emitItens.filter((_,idx)=>idx!==i)); }
  function updateItem(i,k,v) { const n=[...emitItens]; n[i]={...n[i],[k]:v}; setEmitItens(n); }
  function addPag() { setEmitPag([...emitPag, {forma:"01",valor:""}]); }
  function removePag(i) { if(emitPag.length>1) setEmitPag(emitPag.filter((_,idx)=>idx!==i)); }

  function totalItens() { return emitItens.reduce((s,it)=>s+(Number(it.quantidade)||0)*(Number(it.valor_unitario)||0),0); }

  async function emitirNota() {
    setEmitting(true); setEmitMsg("");
    const total = totalItens();
    const pags = emitPag.map(p=>({ forma:p.forma, valor:p.valor?Number(p.valor):total }));
    const itens = emitItens.map(it=>({
      name:it.descricao, quantity:Number(it.quantidade)||1, price:Number(it.valor_unitario)||0,
      ncm:it.ncm||"00000000", cfop:it.cfop||"5102", unidade_comercial:it.unidade||"UN"
    }));
    try {
      const endpoint = emitTipo==="nfce" ? "/api/fiscal/emitir/nfce" : "/api/fiscal/emitir/nfe";
      const body = { itens, pagamentos:pags };
      if(emitCliente.cpf||emitCliente.cnpj||emitCliente.nome) {
        if(emitTipo==="nfce") body.cliente = emitCliente;
        else body.destinatario = emitCliente;
      }
      const r = await apiFetch(endpoint, { method:"POST", body:JSON.stringify(body) });
      setEmitMsg(r.status==="autorizada" ? t("fs.authorized")+r.numero : r.status==="erro" ? "❌ "+r.erro_mensagem : t("fs.sent")+" ("+stLbl(r.status)+")");
      loadNotes();
      if(r.status==="autorizada") { setTimeout(()=>{ setShowEmit(false); setEmitMsg(""); resetEmit(); },2000); }
    } catch(e){ setEmitMsg("❌ "+e.message); }
    setEmitting(false);
  }

  function resetEmit() {
    setEmitCliente({cpf:"",cnpj:"",nome:"",email:""}); setEmitItens([{...emptyItem}]); setEmitPag([{forma:"17",valor:""}]); setEmitTipo("nfce");
  }

  const f = (key,lbl,w,ph) => (
    <div style={{width:w||"100%",minWidth:0}}>
      <label style={label}>{lbl}</label>
      <input style={inp} value={form[key]||""} placeholder={ph||""} onChange={e=>setForm({...form,[key]:e.target.value})}/>
    </div>
  );

  if(loading) return <div style={{padding:40,textAlign:"center",color:"#6B7280"}}>{t("common.loading")}</div>;

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
        <div><h1 style={h1}>{t("fs.title")}</h1><div style={sub}>{t("fs.subtitle")}</div></div>
      </div>
      <div style={{display:"flex",gap:0,marginBottom:20,borderBottom:"2px solid #E5E7EB"}}>
        {[["notes",t("fs.tabNotes")],["config",t("fs.tabConfig")]].map(([id,lbl])=>(
          <div key={id} onClick={()=>setTab(id)} style={{padding:"10px 20px",cursor:"pointer",fontSize:13,fontWeight:tab===id?600:400,color:tab===id?"#B45309":"#6B7280",borderBottom:tab===id?"2px solid #F59E0B":"2px solid transparent",marginBottom:-2}}>{lbl}</div>
        ))}
      </div>

      {tab==="notes" && (
        <div>
          <div style={{...card,position:"relative"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <h3 style={{fontSize:15,fontWeight:600,color:"#111827",margin:0}}>{t("fs.issued")}</h3>
              <div style={{display:"flex",gap:8}}>
                <button style={btnS} onClick={loadNotes}>{t("fs.refresh")}</button>
                <button style={btnP} onClick={()=>{resetEmit();setShowEmit(true)}}>{t("fs.emit")}</button>
              </div>
            </div>
            {notes.length===0 ? (
              <div style={{padding:40,textAlign:"center",color:"#9CA3AF",fontSize:14}}>{t("fs.none")}</div>
            ):(
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead><tr style={{borderBottom:"1px solid #E5E7EB",color:"#6B7280",fontSize:11,textTransform:"uppercase"}}>
                  <th style={{padding:"8px 6px",textAlign:"left"}}>{t("cl.type")}</th>
                  <th style={{padding:"8px 6px",textAlign:"left"}}>{t("fs.number")}</th>
                  <th style={{padding:"8px 6px",textAlign:"left"}}>{t("sl.status")}</th>
                  <th style={{padding:"8px 6px",textAlign:"right"}}>{t("os.value")}</th>
                  <th style={{padding:"8px 6px",textAlign:"left"}}>{t("sl.date")}</th>
                  <th style={{padding:"8px 6px",textAlign:"left"}}>Chave</th>
                  <th style={{padding:"8px 6px",textAlign:"center"}}>{t("cl.actions")}</th>
                </tr></thead>
                <tbody>{notes.map(n=>(
                  <tr key={n.id} style={{borderBottom:"1px solid #F3F4F6"}}>
                    <td style={{padding:"8px 6px"}}>{(n.tipo||"").toUpperCase()}</td>
                    <td style={{padding:"8px 6px"}}>{n.numero||"-"}</td>
                    <td style={{padding:"8px 6px"}}><span style={badgeS(n.status)}>{stLbl(n.status||"pendente")}</span></td>
                    <td style={{padding:"8px 6px",textAlign:"right"}}>R$ {Number(n.valor_total||0).toFixed(2)}</td>
                    <td style={{padding:"8px 6px"}}>{n.emitida_em?new Date(n.emitida_em).toLocaleDateString(dLoc()):n.created_at?new Date(n.created_at).toLocaleDateString(dLoc()):"-"}</td>
                    <td style={{padding:"8px 6px",fontSize:10,fontFamily:"monospace",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{n.chave_nfe||"-"}</td>
                    <td style={{padding:"8px 6px",textAlign:"center"}}>
                      {n.danfe_url&&<a href={n.danfe_url} target="_blank" rel="noreferrer" style={{color:"#F59E0B",marginRight:8,fontSize:12}}>PDF</a>}
                      {n.xml_url&&<a href={n.xml_url} target="_blank" rel="noreferrer" style={{color:"#6B7280",fontSize:12}}>XML</a>}
                      {n.status==="erro"&&n.erro_mensagem&&<span title={n.erro_mensagem} style={{cursor:"help",color:"#DC2626",marginLeft:6}}>⚠</span>}
                    </td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>

          {/* Modal Emitir Nota */}
          {showEmit && (
            <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,.4)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={e=>{if(e.target===e.currentTarget)setShowEmit(false)}}>
              <div style={{background:"#fff",borderRadius:12,padding:24,width:720,maxHeight:"90vh",overflow:"auto",boxShadow:"0 20px 60px rgba(0,0,0,.2)"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
                  <h2 style={{fontSize:18,fontWeight:600,color:"#111827",margin:0}}>{t("fs.emitTitle")}</h2>
                  <button onClick={()=>setShowEmit(false)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:"#6B7280"}}>✕</button>
                </div>

                {/* Tipo */}
                <div style={{display:"flex",gap:12,marginBottom:16}}>
                  {[["nfce","NFCe (Consumidor)"],["nfe","NFe (Produto)"]].map(([v,l])=>(
                    <label key={v} style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:13,color:emitTipo===v?"#B45309":"#6B7280",fontWeight:emitTipo===v?600:400}}>
                      <input type="radio" name="tipo" checked={emitTipo===v} onChange={()=>setEmitTipo(v)} /> {l}
                    </label>
                  ))}
                </div>

                {/* Cliente/Destinatário */}
                <div style={{background:"#F9FAFB",borderRadius:8,padding:14,marginBottom:16}}>
                  <div style={{fontSize:12,fontWeight:600,color:"#374151",marginBottom:10}}>{emitTipo==="nfce"?t("fs.clientOpt"):t("fs.recipient")}</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                    <div><label style={label}>CPF</label><input style={inp} value={emitCliente.cpf} placeholder="000.000.000-00" onChange={e=>setEmitCliente({...emitCliente,cpf:e.target.value})}/></div>
                    <div><label style={label}>CNPJ</label><input style={inp} value={emitCliente.cnpj} placeholder="00.000.000/0000-00" onChange={e=>setEmitCliente({...emitCliente,cnpj:e.target.value})}/></div>
                    <div><label style={label}>{t("cl.name")}</label><input style={inp} value={emitCliente.nome} onChange={e=>setEmitCliente({...emitCliente,nome:e.target.value})}/></div>
                    <div><label style={label}>Email</label><input style={inp} value={emitCliente.email} onChange={e=>setEmitCliente({...emitCliente,email:e.target.value})}/></div>
                  </div>
                </div>

                {/* Itens */}
                <div style={{marginBottom:16}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                    <div style={{fontSize:12,fontWeight:600,color:"#374151"}}>{t("fs.items")}</div>
                    <button style={btnS} onClick={addItem}>{t("fs.addItem")}</button>
                  </div>
                  {emitItens.map((it,i)=>(
                    <div key={i} style={{display:"grid",gridTemplateColumns:"2fr 60px 100px 100px 80px 60px 30px",gap:8,marginBottom:8,alignItems:"end"}}>
                      <div><label style={label}>{t("os.desc")}</label><input style={inp} value={it.descricao} onChange={e=>updateItem(i,"descricao",e.target.value)}/></div>
                      <div><label style={label}>{t("sl.qty")}</label><input style={inp} type="number" min="1" value={it.quantidade} onChange={e=>updateItem(i,"quantidade",e.target.value)}/></div>
                      <div><label style={label}>{t("fs.unitPrice")}</label><input style={inp} type="number" step="0.01" value={it.valor_unitario} onChange={e=>updateItem(i,"valor_unitario",e.target.value)}/></div>
                      <div><label style={label}>NCM</label><input style={inp} value={it.ncm} placeholder="00000000" onChange={e=>updateItem(i,"ncm",e.target.value)}/></div>
                      <div><label style={label}>CFOP</label><input style={inp} value={it.cfop} onChange={e=>updateItem(i,"cfop",e.target.value)}/></div>
                      <div><label style={label}>UN</label><input style={inp} value={it.unidade} onChange={e=>updateItem(i,"unidade",e.target.value)}/></div>
                      <div style={{paddingBottom:2}}>{emitItens.length>1&&<button onClick={()=>removeItem(i)} style={{background:"none",border:"none",color:"#DC2626",cursor:"pointer",fontSize:16}}>✕</button>}</div>
                    </div>
                  ))}
                </div>

                {/* Pagamento */}
                <div style={{marginBottom:16}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                    <div style={{fontSize:12,fontWeight:600,color:"#374151"}}>{t("fs.payment")}</div>
                    <button style={btnS} onClick={addPag}>{t("fs.addPay")}</button>
                  </div>
                  {emitPag.map((p,i)=>(
                    <div key={i} style={{display:"grid",gridTemplateColumns:"2fr 1fr 30px",gap:8,marginBottom:8,alignItems:"end"}}>
                      <div><label style={label}>{t("fs.payForm")}</label>
                        <select style={inp} value={p.forma} onChange={e=>{const n=[...emitPag];n[i].forma=e.target.value;setEmitPag(n);}}>
                          {FORMAS_PAG.map(fp=><option key={fp.v} value={fp.v}>{fp.l}</option>)}
                        </select>
                      </div>
                      <div><label style={label}>{t("fs.valueEmpty")}</label><input style={inp} type="number" step="0.01" value={p.valor} placeholder={totalItens().toFixed(2)} onChange={e=>{const n=[...emitPag];n[i].valor=e.target.value;setEmitPag(n);}}/></div>
                      <div style={{paddingBottom:2}}>{emitPag.length>1&&<button onClick={()=>removePag(i)} style={{background:"none",border:"none",color:"#DC2626",cursor:"pointer",fontSize:16}}>✕</button>}</div>
                    </div>
                  ))}
                </div>

                {/* Total + Emitir */}
                <div style={{borderTop:"1px solid #E5E7EB",paddingTop:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontSize:16,fontWeight:600,color:"#111827"}}>{t("os.total")}: R$ {totalItens().toFixed(2)}</div>
                  <div style={{display:"flex",gap:10,alignItems:"center"}}>
                    {emitMsg&&<span style={{fontSize:12,maxWidth:300}}>{emitMsg}</span>}
                    <button style={{...btnS}} onClick={()=>setShowEmit(false)}>{t("common.cancel")}</button>
                    <button style={btnP} onClick={emitirNota} disabled={emitting||!emitItens[0].descricao}>{emitting?t("fs.emitting"):t("fs.emitBtn")+" "+emitTipo.toUpperCase()}</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {tab==="config" && (
        <div style={card}>
          <h3 style={{fontSize:15,fontWeight:600,color:"#111827",marginTop:0,marginBottom:16}}>Dados do Emitente</h3>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:16}}>
            {f("cnpj","CNPJ *",null,"00.000.000/0000-00")}
            {f("inscricao_estadual","Inscrição Estadual")}
            {f("razao_social","Razão Social *")}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
            {f("nome_fantasia","Nome Fantasia")}
            <div><label style={label}>Regime Tributário *</label>
              <select style={inp} value={form.regime_tributario||1} onChange={e=>setForm({...form,regime_tributario:Number(e.target.value)})}>
                <option value={1}>Simples Nacional</option><option value={2}>Simples Nacional - Excesso</option><option value={3}>Regime Normal</option>
              </select></div>
          </div>
          <h3 style={{fontSize:15,fontWeight:600,color:"#111827",marginTop:24,marginBottom:16}}>Endereço</h3>
          <div style={{display:"grid",gridTemplateColumns:"1fr 2fr 1fr",gap:12,marginBottom:12}}>
            {f("cep","CEP")}{f("logradouro","Logradouro")}{f("numero","Número")}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:12,marginBottom:16}}>
            {f("bairro","Bairro")}{f("municipio","Município")}{f("codigo_municipio","Cód. IBGE")}{f("uf","UF",null,"SP")}
          </div>
          <h3 style={{fontSize:15,fontWeight:600,color:"#111827",marginTop:24,marginBottom:16}}>API Focus NFe</h3>
          <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",gap:12,marginBottom:12}}>
            {f("focus_token","Token da API")}
            <div><label style={label}>Ambiente *</label>
              <select style={inp} value={form.ambiente||2} onChange={e=>setForm({...form,ambiente:Number(e.target.value)})}>
                <option value={2}>Homologação (testes)</option><option value={1}>Produção</option>
              </select></div>
            {f("serie_nfce","Série NFCe",null,"1")}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
            {f("csc_id","CSC ID (NFCe)")}{f("csc_token","CSC Token (NFCe)")}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginTop:20}}>
            <button style={btnP} onClick={saveConfig} disabled={saving}>{saving?t("os.saving"):t("fs.saveConfig")}</button>
            {msg&&<span style={{fontSize:13,color:msg.startsWith(t("fs.error").slice(0,4))?"#DC2626":"#059669"}}>{msg}</span>}
          </div>
        </div>
      )}
    </div>
  );
}
